import React from "react";
import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../../components/Global/OrderColumn";
import useService from "./useService";
import AddService from "./AddService";
import { Table } from "../../Global/Table"; 
const Service = () => {
  const {
    serviceState,
    showEditModal,
    tableFields,
    serviceList,
    isLoading,
    isFetching,
    paginationOptions,
    getRow,
    handleEditColumnsClick,
    handleSort,
    handlePagination,
    handleModalClick,
    handleDelete,
    handleDeleteModal,
    handleEditAction,
    handleSearch,
    updateServiceFields,
    handleClearClick,
    handlePageSize,
    refetch,
  } = useService();
  return (
    <div>
      <HeadingGroup
        title={"All Services"}
        className={`pro-mb-4`}
        buttonTitle={serviceList?.data?.create_permission && "Add new"}
        handleClick={handleModalClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          showActions={true}
          handleActionClick={handleEditColumnsClick}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters
          handleClear={handleClearClick}
          searchInputProps={{ value: serviceState?.search , placeholder:" Search Name, Process" }}
        />
        <Table
          multiSelect={false}
          data={serviceList?.data?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          editIcon={<span className="material-symbols-outlined">edit</span>}
          deleteIcon={<span className="material-symbols-outlined">delete</span>}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          clear={serviceState.clearSelection}
          perpage={serviceState?.currentPageSize}
          assignable={false}
          handleEdit={handleEditAction}
          handleDelete={handleDeleteModal}
          deletable={serviceList?.data?.delete_permission}
          editable={serviceList?.data?.edit_permission}
          showCheckBox={true}
        />
        {serviceList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={serviceState?.currentPage}
            totalPageCount={Math.ceil(
              serviceList?.data?.total_count / serviceState.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={serviceState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure delete the selected service ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={serviceList?.data?.fields}
              moduleId={serviceList?.data?.module_id}
              updateData={updateServiceFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={serviceState?.showAddServiceModal}
          handleClose={handleModalClick}
          title={serviceState?.isEdit ? "Edit Service" : "Add Service"}
          closeIcon={<span className="material-symbols-outlined"> close </span>}
        >
          <AddService refetch={refetch} />
        </ModalLayout>
      </div>
    </div>
  );
};

export default Service;
